// Hide Spotlight everywhere except the Blog page
(function() {
  function hideSpotlight() {
    var path = window.location.pathname;
    var isBlogPage = path === '/pages/blog' || path === '/pages/blog/';
    
    if (isBlogPage) return;
    
    // Find all Spotlight elements
    var spotlights = document.querySelectorAll('[class*="ai-spotlight-"]');
    
    spotlights.forEach(function(el) {
      // Only target the container div (class without __ suffix)
      // Inner elements have __ in their class (e.g., __heading, __card)
      var classes = el.className.split(' ');
      for (var i = 0; i < classes.length; i++) {
        var c = classes[i];
        if (c.indexOf('ai-spotlight-') === 0 && c.indexOf('__') === -1) {
          // This is the container - hide it and its parent section if needed
          el.style.setProperty('display', 'none', 'important');
          // Also hide parent section for good measure
          var parent = el.closest('section');
          if (parent) {
            parent.style.setProperty('display', 'none', 'important');
          }
          break;
        }
      }
    });
  }
  
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideSpotlight);
  } else {
    hideSpotlight();
  }
  
  // Also run after a short delay in case content loads async
  setTimeout(hideSpotlight, 1000);
  setTimeout(hideSpotlight, 3000);
})();
